import { render, staticRenderFns } from "./Psp.vue?vue&type=template&id=523f31cb&scoped=true"
import script from "./Psp.vue?vue&type=script&lang=js"
export * from "./Psp.vue?vue&type=script&lang=js"
import style0 from "./Psp.vue?vue&type=style&index=0&id=523f31cb&prod&scoped=true&lang=css"
import style1 from "./Psp.vue?vue&type=style&index=1&id=523f31cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f31cb",
  null
  
)

export default component.exports